'use client';
import React from 'react';
import { useEffect, useState } from "react";
import { createPortal } from "react-dom"

const contentWidth = 350;

function Overlay({ children, onClose, anchorRef }) {
    const [style, setStyle] = useState({});

    useEffect(() => {
        document.documentElement.classList.add('mio-overlay');
        if (anchorRef?.current) {
            const rect = anchorRef.current.getBoundingClientRect();
            const viewportHeight = window.innerHeight;
            const availableHeight = viewportHeight - rect.bottom - 10;
            const left = Math.max(0, rect.right - contentWidth);
            // console.log(rect, viewportHeight, availableHeight);
            // console.log(rect.right, contentWidth, rect.right - contentWidth);
            setStyle({
                position: 'fixed',
                top: `${rect.bottom}px`,
                left: `${left}px`,
                width: `${contentWidth}px`,
                opacity: 1,
                maxHeight: `${availableHeight}px`,
                overflow: 'hidden'
            });
        }


        const handleKeyDown = (event) => {
            if (event.key === 'Tab') {
                event.preventDefault();
                event.stopPropagation();
                onClose()
            }
        }
        document.addEventListener('keydown', handleKeyDown, true);

        return () => {
            document.removeEventListener('keydown', handleKeyDown, true);
            document.documentElement.classList.remove('mio-overlay');
        };
    }, [])

    return createPortal(<div className="mio-form-overlay" onClick={onClose}>
        <div style={style} className="mio-form-overlay-content">
            {children}
        </div>
    </div>, document.body);
}
export default Overlay